import { useEffect, useState } from 'react'
import { Button } from 'antd'
import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { UserSwitchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { api } from '../lib/api'
import { errorResponse } from '../lib/errorResponse'
import { functionsRegion } from '../config/firebaseConfig'

export default function ImpersonationExitButton({ auth: authProp }) {
  const { t } = useTranslation()
  const auth = authProp || getAuth()
  const [claims, setClaims] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        if (!cancelled) setClaims(null)
        return
      }
      try {
        const token = await user.getIdTokenResult()
        if (!cancelled) {
          setClaims(token.claims.impersonating === true ? token.claims : null)
        }
      } catch (_e) {
        if (!cancelled) setClaims(null)
      }
    })
    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [auth])

  if (!claims) {
    return null
  }

  async function endImpersonation() {
    try {
      setLoading(true)
      const functions = getFunctions(auth.app, functionsRegion)
      const data = await api(functions, 'impersonate/stop')
      const customToken = data?.customToken
      if (customToken) {
        try {
          await signInWithCustomToken(auth, customToken)
          window.location.replace(
            claims.exitPath || claims.returnPath || '/admin'
          )
        } catch (_e) {
          Sentry.setUser(null)
          await signOut(auth)
          window.location.replace('/login')
        }
      } else {
        Sentry.setUser(null)
        await signOut(auth)
        window.location.replace('/login')
      }
    } catch (e) {
      errorResponse(e)
      setLoading(false)
    }
  }

  return (
    <Button
      danger
      size="large"
      icon={<UserSwitchOutlined />}
      loading={loading}
      onClick={endImpersonation}
    >
      {t('frontend:impersonation.exitImpersonation')}
    </Button>
  )
}
